export default __webpack_public_path__ + "static/media/Headphone.0386a7ac.svg";